import { Component, OnInit } from "@angular/core";
import {
  AlertController,
  IonSlides,
  ModalController,
  NavController,
  PopoverController,
  ToastController,
} from "@ionic/angular";
import {
  FilterComponent,
  IFilterData,
  TransactionStatus,
} from "src/app/components/filter/filter.component";
import { AppService } from "src/app/service/app.service";
import { TransactionModel } from "src/app/const/transaction-model.enum";
import { DataService } from "src/app/service/data.service";

@Component({
  selector: "app-wayyak-transaction",
  templateUrl: "./wayyak-transaction.page.html",
  styleUrls: ["./wayyak-transaction.page.scss"],
})
export class WayyakTransactionPage implements OnInit {
  wayyakLoading: boolean = false;
  wayyakPendingRequest: any = [];
  pageNumber = 1;
  search = "";
  startDate = "";
  endDate = "";
  status: any = 0;

  filterData?: IFilterData;

  constructor(
    private dataService: DataService,
    private modalCtrl: ModalController,
    public alertController: AlertController,
    public appService: AppService,

  ) {
    this.getWayyakRequest();
  }

  ngOnInit() {}

  getWayyakRequest(scrollEvent?) {
    if (!scrollEvent) this.wayyakLoading = true;

    let params = {
      page: this.pageNumber,
      search: this.search,
      startDate: this.startDate,
      endDate: this.endDate,
      status: this.status,
    };

    this.dataService.getWayyakPendingRequest(params).subscribe(
      (res: any) => {
        if (this.wayyakPendingRequest.length === 0 && this.pageNumber === 1) {
          this.wayyakPendingRequest = res.data;
        } else if (
          res.data.length !== 0 &&
          this.wayyakPendingRequest.length !== 0
        ) {
          if (this.search.length !== 0) {
            this.wayyakPendingRequest = res.data;
          } else {
            this.wayyakPendingRequest.push(...res.data);
          }
        } else if (res.data.length === 0 && this.pageNumber > 1) {
          this.resetPage();
        } else {
          this.wayyakPendingRequest = res.data;
        }
        this.wayyakLoading = false;
        if (scrollEvent) scrollEvent.target.complete();
      },
      (err) => {
        this.resetPage();
        this.wayyakLoading = false;
        if (scrollEvent) scrollEvent.target.complete();
      }
    );
  }

  resetPage() {
    if (this.pageNumber !== 1) this.pageNumber -= 1;
  }

  searchTransaction(event: any) {
    this.search = event.target.value;
    this.getWayyakRequest();
  }

  /**
   * @method { Event trigger scroll on load }
   * @memberof TransactionsPage
   */
  loadDataOnScroll(event) {
    this.pageNumber += 1;
    this.getWayyakRequest(event);
  }

  async filter() {
    const modal = await this.modalCtrl.create({
      component: FilterComponent,
      componentProps: {
        transactionModel: TransactionModel.WAYYAK,
        isStatusEnabled: true,
        filterData: this.filterData,
      },
    });
    modal.present();
    this.filterData = await (await modal.onWillDismiss()).data;
    this.wayyakPendingRequest = [];
    this.endDate = this.filterData.endDate;
    this.startDate = this.filterData.fromDate;
    this.status = this.filterData.status;
    this.getWayyakRequest();
  }

  filterActive() {
    if (
      this.startDate ||
      this.endDate ||
      this.status != TransactionStatus.ALL
    ) {
      return true;
    }
    return false;
  }




  async cancelWayyakLink(i) {
    const alert = await this.alertController.create({
      header: 'Are you sure?',
      message: 'Do you want to cancel Wayyak link?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        }, {
          text: 'Yes',
          handler: () => {
            this.wayyakLoading = true;
            this.dataService.updateWayyakStatus(i).subscribe((res: any) => {
              this.wayyakLoading = false;
              this.getWayyakRequest();



            }, (err) => {
              this.wayyakLoading = false;
            });

          }
        }
      ]
    });
    await alert.present();

  }
}
